(() => {
  if (window.__ciranovaColorPreviewLoaded) return;
  window.__ciranovaColorPreviewLoaded = true;

  function updatePreview(preview, variant) {
    const variantsNode = preview.querySelector('[data-cn-color-preview-variants]');
    if (!variantsNode || !variant?.id) return;

    let entries;
    try {
      entries = JSON.parse(variantsNode.textContent);
    } catch (error) {
      return;
    }

    const selected = entries.find((entry) => String(entry.id) === String(variant.id));
    if (!selected) return;

    const representative = selected.image
      ? selected
      : entries.find((entry) => entry.color === selected.color && entry.image);
    if (!representative?.image) return;

    const image = preview.querySelector('[data-cn-color-preview-image]');
    const name = preview.querySelector('[data-cn-color-preview-name]');

    if (image) {
      image.src = representative.image;
      image.removeAttribute('srcset');
      image.alt = selected.color || 'Selected color';
    }
    if (name) name.textContent = selected.color || '';
  }

  document.addEventListener('variant:change', (event) => {
    const variant = event?.detail?.variant;
    if (!variant?.id) return;

    document.querySelectorAll('[data-cn-color-preview]').forEach((preview) => {
      updatePreview(preview, variant);
    });
  }, true);
})();
